import { BottomSheetBackdrop, BottomSheetModal, BottomSheetView } from '@gorhom/bottom-sheet'
import React, { RefObject, useCallback, useMemo } from 'react'
import { styles } from './NotificationSheet.styles'
import { NotificationSheetContent } from './NotificationSheetContent'
import { useStore } from '../../models'
import { ReduceMotion } from 'react-native-reanimated'

type CheatSheetProps = {
  bottomNotificationSheetModalRef: RefObject<BottomSheetModal | null>
}

type TRenderProps = { data: { dayOfWeek?: number } } | undefined

const NotificationCheatSheet = ({ bottomNotificationSheetModalRef }: CheatSheetProps) => {
  const {
    session: { setIsPNSheetOpen }
  } = useStore()

  const renderBackdrop = useCallback(
    (props: React.ComponentProps<typeof BottomSheetBackdrop>) => (
      <BottomSheetBackdrop {...props} disappearsOnIndex={-1} appearsOnIndex={0} />
    ),
    []
  )

  const snapPoints = useMemo(() => ['85%'], [])

  return (
    <BottomSheetModal
      ref={bottomNotificationSheetModalRef}
      index={0}
      snapPoints={snapPoints}
      enableContentPanningGesture={false}
      enableDynamicSizing={false}
      backdropComponent={renderBackdrop}
      detached={false}
      handleStyle={styles.bottomSheetHandleStyle}
      handleIndicatorStyle={styles.bottomSheetIndicatorStyle}
      keyboardBlurBehavior="restore"
      onDismiss={() => {
        setIsPNSheetOpen(false)
      }}
      overrideReduceMotion={ReduceMotion.System}
    >
      <NotificationSheetContent dayOfWeek={undefined} />
    </BottomSheetModal>
  )
}

export default NotificationCheatSheet
